// Sets the first day of the week, starting with 0 for Sunday.
export const FIRST_DAY_OF_WEEK = {
  Sunday: '0',
  Monday: '1',
  Saturday: '6'
} as const

export type FirstDayOfWeek =
  (typeof FIRST_DAY_OF_WEEK)[keyof typeof FIRST_DAY_OF_WEEK]
